import { ArrowLeftIcon } from '@heroicons/react/24/solid'
import { ReactNode } from 'react'

import { AppButton } from '@/components/shared/button'
import { AppModal } from '@/components/shared/modal'

import { FixedBottomDrawerButton } from '../../FixedBottomDrawerButton'

type Props = {
  onClose: () => void
  placeholder: string
  isOpen: boolean
  children: ReactNode
  premiseName: string
  projectName: string
}

export const MobilePremisePermissionsPicker = ({
  onClose,
  placeholder,
  isOpen,
  children,
  premiseName,
  projectName
}: Props) => (
  <AppModal
    className="mx-0 h-full w-full rounded-0 !bg-grey-10"
    headerWrapperClassName="px-16"
    contentClassName="gap-8 mt-20 mb-[80px] px-16 overflow-y-auto"
    header={
      <div className="flex items-center gap-24">
        <AppButton
          aria-label="Вернуться назад"
          variant="uncolored"
          className="!h-28 !p-0"
          onClick={onClose}
        >
          <ArrowLeftIcon className="h-28 w-28 sm:h-24 sm:w-24" />
        </AppButton>
        <span className="text-20">{placeholder}</span>
      </div>
    }
    opened={isOpen}
    onClose={onClose}
  >
    <div className="pb-20 text-grey-80 text-16">
      <span className="font-semibold">{projectName}</span>{' '}
      <span className="mx-4 inline-block h-4 w-4 translate-y-[-3px] rounded-full bg-grey-70" />{' '}
      <span>{premiseName}</span>
    </div>
    {children}
    <FixedBottomDrawerButton text="Выбрать" onClick={onClose} />
  </AppModal>
)
